import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiderStoreShallow } from '@refly/stores';
import { shouldExpandSider } from './route-collapse';

/**
 * Custom hook to handle sidebar collapse state based on route changes
 * Sets collapseState to 'expanded' for specific routes, 'hidden' for all others
 */
export const useRouteCollapse = () => {
  const location = useLocation();
  const { collapseState, isManualCollapse, setCollapseState } = useSiderStoreShallow((state) => ({
    collapseState: state.collapseState,
    isManualCollapse: state.isManualCollapse,
    setCollapseState: state.setCollapseState,
  }));

  useEffect(() => {
    if (isManualCollapse) {
      return;
    }

    const currentPath = location.pathname;

    // Set collapse state based on route
    // If shouldExpand is true, set collapseState to 'expanded'
    // If shouldExpand is false, set collapseState to 'hidden'
    const nextState = shouldExpandSider(currentPath) ? 'expanded' : 'hidden';
    if (collapseState !== nextState) {
      setCollapseState(nextState);
    }
  }, [collapseState, isManualCollapse, location.pathname, setCollapseState]);
};
